import styled from "styled-components";

export const ContainerLoading = styled.div`
    flex: auto;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Container = styled.div`
    margin-left: 5rem;
    margin-right: 1rem;
`;

export const Form = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 1rem 0;

    @media (max-width: 1000px){
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .form-register{
        width: 100%;
        input{
            margin-left: 1rem;
            padding: 2px 6px;
            margin-left: 5px;
            border: 1px solid var(--mainTheme);
            font-size: 1rem;
            border-radius: 3px;
        }

        @media (max-width: 1000px){
            display: flex;
            flex-direction: column;
            margin-bottom: 1rem;

            input{
                width: 100%;
                margin-bottom: 10px;
                padding: 4px 8px;
                margin-left: 0;
            }
        }
    }

    .buttons-filter{
        display: flex;
        flex-direction: column;
        justify-content: center;

        @media (max-width: 1000px){
            width: 100%;
            flex-direction: row;
            justify-content: space-around;
        }

        @media(max-width: 400px){
            flex-direction: column;
        }

        .radio{
            display: flex;
            align-items: center;

            label{
                margin-left: 10px;
                color: #4A007A;
            }

            input{
                appearance: none;
                width: 15px;
                height: 15px;
                border-radius: 100%;
                border: 1px solid #4A007A;
                outline: none;
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                

                &:before{
                    content: '';
                   
                    height: 10px;
                    width: 10px;
                    border-radius: 100%;
                    background: #4A007A;;
                    opacity: 0;
                }

                &:checked:before{
                    opacity: 1;
                }
            }

            @media (max-width: 400px){
                margin-top: 5px;
            }
        }
    }

    button{
        margin-left: 1rem;
        padding: 2px 8px;
        border: none;
        background-color: var(--mainTheme);
        color: #fff;
        border-radius: 3px;
        font-size: 1rem;

        @media (max-width: 1000px){
            width: 100%;
            margin-left: 0;
            padding: 4px 8px;
        }
    }
`;

export const Content = styled.div`
    overflow: scroll;
    scroll-behavior: auto;

    &::-webkit-scrollbar-track {
        background-color: #FFF;
    }

    &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background: #C3C3C3;
        border-radius: 4px;
    }

    scrollbar-width: thin;
    scrollbar-color: #C3C3C3;
    scrollbar-track-color: #FFF; 
`;

export const Table = styled.table`
    margin: 25px 0;
    font-size: 0.9rem;
    width: 100%; 
    color: var(--colorFontsCardsDashboard);

    thead{
        tr{
            background: var(--colorBackgroundCardsDashboard);
            
            th{
                font-size: 17px;
                text-align: right;
         

                @media(max-width: 800px){
                    font-size: 15px;
                }

                @media(max-width: 700px){
                    font-size: 13px;
                }
            }

            th:nth-child(2),th:nth-child(3){
                text-align: left;
            }

            .isNone{
                @media(max-width: 900px){
                    display: none
                }
            }
        }
    }

    tbodY{
        tr{
            border-bottom: 1px solid #DDD;
            text-align: right;
            width: 25%;

            td{
                &:first-child{
                    text-align: center;
                }

                &:nth-child(2),&:nth-child(3){
                    text-align: left;
                }

                @media(max-width: 400px){
                    &:last-child{
                        width: 35%;
                    }
                }
            }

            .last-column{
                button{
                    background: transparent;
                    border: none;

                    svg{
                        font-size: 1.2rem;
                        color: #4A007A;
                    }

                    .svg-confirm{
                        color: #2e9699;
                    }

                    .svg-delete{
                        color: #e05f59;
                    }
                }

                button + button{
                    margin-left: 15px;
                }
            }

            &:nth-child(even){
                background: #f2f2f2;
            }

            .isNone{
                @media(max-width: 900px){
                    display: none
                }
            }
        }
    }

    th, td{
        padding: 0.15rem 0.35rem;
        font-size: 15px;
        height: 40px;

        @media(max-width: 800px){
            font-size: 13px;
        }

        @media(max-width: 700px){
            font-size: 12px;
        }
    }
`;